import { __extends } from "tslib";
import { AssetBase, AssetEvent } from "@awayjs/core";
/**
 * @class away.partition.Partition
 */
var PartitionBase = /** @class */ (function (_super) {
    __extends(PartitionBase, _super);
    function PartitionBase(root, isScene) {
        if (isScene === void 0) { isScene = false; }
        var _this = _super.call(this) || this;
        _this._children = new Array();
        _this._abstractionPool = new Object();
        _this._updateQueue = {};
        _this.isUpdated = false;
        _this._root = root;
        _this._root.addEventListener(AssetEvent.CLEAR, function (event) { return _this._onRootClear(event); });
        if (isScene)
            _this._scene = root;
        return _this;
    }
    Object.defineProperty(PartitionBase.prototype, "parent", {
        get: function () {
            return this._parent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PartitionBase.prototype, "root", {
        get: function () {
            return this._root;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PartitionBase.prototype, "scene", {
        get: function () {
            return this._scene;
        },
        enumerable: true,
        configurable: true
    });
    PartitionBase.prototype.addChild = function (child) {
        if (child && child.parent)
            child.parent.removeChildInternal(child);
        this._children.push(child);
        child._setParent(this);
        return child;
    };
    PartitionBase.prototype.removeChild = function (child) {
        this.removeChildInternal(child);
        child._setParent(null);
        return child;
    };
    PartitionBase.prototype.removeChildInternal = function (child) {
        return this._children.splice(this._children.indexOf(child), 1)[0];
    };
    PartitionBase.prototype.getAbstraction = function (entity) {
        return (this._abstractionPool[entity.id] || (this._abstractionPool[entity.id] = new PartitionBase._abstractionClassPool[entity.assetType](entity, this)));
    };
    PartitionBase.prototype.getPartition = function (entity) {
        return null;
    };
    /**
     *
     * @param image
     */
    PartitionBase.prototype.clearAbstraction = function (entity) {
        delete this._abstractionPool[entity.id];
    };
    PartitionBase.prototype.traverse = function (traverser) {
        this.isUpdated = this._invalid;
        this._invalid = false;
        this._rootNode.acceptTraverser(traverser);
    };
    PartitionBase.prototype.invalidateEntity = function (entity) {
        if (!this._invalid)
            this.invalidate();
        this._updateQueue[entity.id] = entity;
    };
    PartitionBase.prototype.updateEntity = function (entity) {
        //TODO: remove reliance on view
        //required for controllers with autoUpdate set to true and queued events
        entity._iInternalUpdate();
        this.updateNode(this.getAbstraction(entity));
    };
    PartitionBase.prototype.updateNode = function (node) {
        var targetNode = this.findParentForNode(node);
        if (targetNode && node.parent != targetNode) {
            if (node.parent)
                node.parent.iRemoveNode(node);
            targetNode.iAddNode(node);
        }
    };
    PartitionBase.prototype.clearEntity = function (entity) {
        if (!this._invalid)
            this.invalidate();
        delete this._updateQueue[entity.id];
        this.clearNode(this.getAbstraction(entity));
    };
    PartitionBase.prototype.clearNode = function (node) {
        if (node.parent) {
            node.parent.iRemoveNode(node);
            node.parent = null;
        }
    };
    /**
     *
     * @param entity
     * @returns {away.partition.NodeBase}
     */
    PartitionBase.prototype.findParentForNode = function (node) {
        return this._rootNode;
    };
    PartitionBase.prototype.updateEntities = function () {
        for (var key in this._updateQueue)
            this.updateEntity(this._updateQueue[key]);
        //clear updateQueue
        this._updateQueue = {};
    };
    PartitionBase.prototype.invalidate = function () {
        this._invalid = true;
        _super.prototype.invalidate.call(this);
        if (this._parent)
            this._parent.invalidate();
    };
    PartitionBase.prototype.dispose = function () {
        for (var key in this._abstractionPool)
            this._abstractionPool[key].onClear(null);
    };
    PartitionBase.prototype._setParent = function (parent) {
        if (this._parent) {
            this._parent.clearNode(this._rootNode);
            this._parent.invalidate();
        }
        this._parent = parent;
        if (parent) {
            parent.updateNode(this._rootNode);
            parent.invalidate();
        }
        this._setScene(parent ? parent.scene : null);
    };
    PartitionBase.prototype._setScene = function (scene) {
        if (this._scene == scene)
            return;
        this._scene = scene;
        var len = this._children.length;
        for (var i = 0; i < len; ++i)
            this._children[i]._setScene(scene);
    };
    PartitionBase.prototype._onRootClear = function (event) {
        this.clear();
        this._abstractionPool;
    };
    /**
     *
     * @param imageObjectClass
     */
    PartitionBase.registerAbstraction = function (entityNodeClass, assetClass) {
        PartitionBase._abstractionClassPool[assetClass.assetType] = entityNodeClass;
    };
    PartitionBase._abstractionClassPool = new Object();
    return PartitionBase;
}(AssetBase));
export { PartitionBase };
